import { render } from "./Result2.vue?vue&type=template&id=1b34f855"
import script from "./Result2.vue?vue&type=script&lang=ts"
export * from "./Result2.vue?vue&type=script&lang=ts"
script.render = render

export default script